import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import moment from 'moment'
import {apiGetShareFileInfo} from '../../redux/api'
import {toast} from 'react-toastify'

function ShareLink({className, selectedDevice}: any) {
  const intl = useIntl()
  const [show, setShow] = useState<boolean>(false)
  const [shareFileInfo, setShareFileInfo] = useState<any>(null)

  const handleClose = () => {
    setShow(false)
    setShareFileInfo(null)
  }

  const handleCopy = (text: any) => {
    navigator.clipboard.writeText(text)
  }

  const getShareLink = () => {
    const epochAfter7Days = moment().add(7, 'days').unix()

    const data: any = {
      expiryEpoch: epochAfter7Days,
      fileId: selectedDevice.fileId,
    }

    apiGetShareFileInfo(data)
      .then(({data}: any) => {
        if (data.status === 200) {
          setShow(true)
          setShareFileInfo(data.response)
        } else {
          setShow(false)
          toast.error(
            `${intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_ACCESS_SHARE_LINK'})} : ${data.message}`
          )
        }
      })
      .catch((error) => {
        setShow(false)
        toast.error(
          `${intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_ACCESS_SHARE_LINK'})} : ${error}`
        )
      })
  }
  return (
    <>
      {selectedDevice && selectedDevice.fileId ? (
        <div className={className}>
          <KTSVG path='/media/icons/duotone/General/Sharelink.svg' className='request-file' />

          <span
            className='link-primary text-break text-underline fw-bolder'
            onClick={() => getShareLink()}
          >
            {intl.formatMessage({id: 'DEVICE.SHARE_LINK'})}
          </span>
        </div>
      ) : (
        <></>
      )}

      {show && selectedDevice && selectedDevice.fileId ? (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body>
            <div className='mdt-links-container'>
              <div className='d-flex w-100 align-items-center justify-content-between'>
                <h1 className='text-primary d-flex gap-3 align-items-center'>
                  {intl.formatMessage({id: 'GENERAL.LABEL.SHARE_LINK_TO_VIDEO'})}
                </h1>
                <button className='btn btn-link p-0' type='button' onClick={handleClose}>
                  <i
                    className='fa fa-times-thin fa-2x'
                    aria-hidden='true'
                    style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
                  ></i>
                </button>
              </div>
              <div className='d-flex gap-5 align-items-center'>
                <label className='form-label fs-6 text-dark m-0'>{selectedDevice.VehicleNo}</label>
                <label className='form-label fs-6 m-0 text-gray-600'>
                  {selectedDevice.DeviceId}
                </label>
              </div>
              <div>
                <span className='fw-bolder'>
                  {intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}
                </span>
                :{' '}
                <span className='fw-bold'>
                  {selectedDevice.TimeRange && <>{selectedDevice.TimeRange}</>}
                </span>
              </div>
              <div className='line-break w-100 ' style={{backgroundColor: '#EFF2F5', height: 1}} />

              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'GENERAL.LABEL.VIDEO_LINK'})}
                  </span>
                  : {shareFileInfo?.ShareLink}
                </div>
                <button
                  type='button'
                  className='btn btn-sm border border-primary text-primary copy-btn rounded-3 cursor-pointer'
                  onClick={() => handleCopy(shareFileInfo?.ShareLink)}
                >
                  <KTSVG path='/media/icons/duotone/General/Copy.svg' />
                  {intl.formatMessage({id: 'GENERAL.LABEL.COPY_BUTTON'})}
                </button>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div>
                  <span className='fw-bolder'>
                    {intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
                  </span>
                  : {shareFileInfo?.Password}
                </div>
                <button
                  type='button'
                  className='btn btn-sm border border-primary text-primary copy-btn rounded-3 cursor-pointer'
                  onClick={() => handleCopy(shareFileInfo?.Password)}
                >
                  <KTSVG path='/media/icons/duotone/General/Copy.svg' />
                  {intl.formatMessage({id: 'GENERAL.LABEL.COPY_BUTTON'})}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <></>
      )}
    </>
  )
}

export default ShareLink
